// packages/eden-table/src/components/Table/StickyHeaderContext.jsx
import { createContext } from "react";
var StickyHeaderContext = createContext();
var StickyHeaderContext_default = StickyHeaderContext;
export {
  StickyHeaderContext_default as default
};
